module.exports = __webpack_public_path__ + "static/media/del_btn1.0282859a.svg";